import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
	debounceTime,
	distinctUntilChanged,
	filter,
	finalize,
	Subject,
	switchMap,
	takeUntil,
} from 'rxjs';

import {
	AbstractDynamicForm,
	FormControlWrapper,
} from '../../../dynamic-form-abstract';
import { ServiceProviderDto } from '../../../../../service/dto';
import { HttpServiceProviderService } from '../../../../../service/http-service-provider.service';

@Component({
	selector: 'app-dynamic-form-input-service-provider-id',
	standalone: false,
	templateUrl: './dynamic-form-input-service-provider-id.component.html',
	styleUrl: './dynamic-form-input-service-provider-id.component.scss',
})
export class DynamicFormInputServiceProviderIdComponent
	implements OnInit, OnDestroy
{
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;

	toControlKey = AbstractDynamicForm.toControlKey;

	suggestions: ServiceProviderDto[] = [];
	isLoading = false;
	searchValue = '';

	private searchSubject = new Subject<string>();
	private destroy$ = new Subject<void>();

	constructor(private serviceProviderService: HttpServiceProviderService) {}

	ngOnInit(): void {
		this.searchSubject
			.pipe(
				debounceTime(350),
				distinctUntilChanged(),
				filter((term) => term.length >= 2),
				switchMap((term) => {
					this.isLoading = true;

					return this.serviceProviderService
						.search(term)
						.pipe(finalize(() => (this.isLoading = false)));
				}),
				takeUntil(this.destroy$),
			)
			.subscribe((results) => {
				this.suggestions = results;
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	onSearch(term: string): void {
		this.searchValue = term;

		if (!term) {
			this.suggestions = [];
			return;
		}

		this.searchSubject.next(term);
	}

	selectServiceProvider(
		serviceProvider: ServiceProviderDto,
		event?: MouseEvent,
	): void {
		event?.preventDefault();
		event?.stopPropagation();

		const controlKey = this.toControlKey(this.wrapper.element);
		const control = this.form.get(controlKey);
		const value = serviceProvider.id + '';

		this.searchValue = this.getLabel(serviceProvider);

		control?.setValue(value, { emitEvent: true });
		control?.markAsDirty();
		control?.markAsTouched();
		control?.updateValueAndValidity();

		this.suggestions = [];
	}

	getLabel(opt: ServiceProviderDto): string {
		return opt.name;
	}
}
